<template>
<div class="flex flex-wrap m16-treelogy aspect-ratio-square xl:aspect-ratio-4/3">
  <div class="flex flex-wrap justify-center text-center w-full flex-1 px-5 py-10 md:py-20 xl:px-32">
    <div class="map-section w-1/3">
        <a @mouseover="hoverST = true" @mouseout="hoverST = false" href="/magnificent16/treelogy/ST" class="sphere bluegreen">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverST">
              <span class="text-green-500">Sensing</span> & <span class="text-blue-500">Thinking</span>
            </div>
          </transition>
        </a>
    </div>
    <div class="map-section w-1/3">
        <a @mouseover="hoverET = true" @mouseout="hoverET = false" href="/magnificent16/treelogy/ET" class="sphere blue">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverET">
              Extraverted <span class="text-blue-500">Thinking</span>
            </div>
          </transition>
        </a>
    </div>
    <div class="map-section w-1/3">
        <a @mouseover="hoverNT = true" @mouseout="hoverNT = false" href="/magnificent16/treelogy/NT" class="sphere blueyellow">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverNT">
              <span class="text-yellow-500">Intuition</span> & <span class="text-blue-500">Thinking</span>
            </div>
          </transition>
        </a>
    </div>
    
    <div class="map-section w-full">
        <a @mouseover="hoverIT = true" @mouseout="hoverIT = false" href="/magnificent16/treelogy/IT" class="sphere blue">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverIT">
              Introverted <span class="text-blue-500">Thinking</span>
            </div>
          </transition>
        </a>
    </div>
    
    <div class="map-section w-1/3">
        <a @mouseover="hoverES = true" @mouseout="hoverES = false" href="/magnificent16/treelogy/ES" class="sphere green">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverES">
              Extraverted <span class="text-green-500">Sensing</span>
            </div>
          </transition>
        </a>
    </div>
    <div class="map-section w-1/3">
      <div class="flex flex-wrap flex-1 items-stretch justify-between">
        <div class="map-section w-1/3">
          <a @mouseover="hoverIS = true" @mouseout="hoverIS = false" href="/magnificent16/treelogy/IS" class="sphere green">
            <transition name="fade">
              <div class="text-reveal" v-show="hoverIS">
                Introverted <span class="text-green-500">Sensing</span>
              </div>
            </transition>
          </a>
        </div>
        <div class="map-section w-1/3">
          <a @mouseover="hoverWisdom = true" @mouseout="hoverWisdom = false" href="/magnificent16/treelogy/wisdom" class="sphere white">
            <transition name="fade">
              <div class="text-reveal" v-show="hoverWisdom">
                Seeds of Wisdom
              </div>
            </transition>
          </a>
        </div>
        <div class="map-section w-1/3">
          <a @mouseover="hoverIN = true" @mouseout="hoverIN = false" href="/magnificent16/treelogy/IN" class="sphere yellow">
            <transition name="fade">
              <div class="text-reveal" v-show="hoverIN">
                Introverted <span class="text-yellow-500">Intuition</span>
              </div>
            </transition>
          </a>
        </div>
      </div>
    </div>
    <div class="map-section w-1/3">
        <a @mouseover="hoverEN = true" @mouseout="hoverEN = false" href="/magnificent16/treelogy/EN" class="sphere yellow">
            <transition name="fade">
              <div class="text-reveal" v-show="hoverEN">
                Extraverted <span class="text-yellow-500">Intuition</span>
              </div>
            </transition>
          </a>
    </div>
        
    <div class="map-section w-full">
        <a @mouseover="hoverIF = true" @mouseout="hoverIF = false" href="/magnificent16/treelogy/IF" class="sphere red">
            <transition name="fade">
              <div class="text-reveal" v-show="hoverIF">
                Introverted <span class="text-red-500">Feeling</span>
              </div>
            </transition>
          </a>
    </div>
    
    <div class="map-section w-1/3">
        <a @mouseover="hoverSF = true" @mouseout="hoverSF = false" href="/magnificent16/treelogy/SF" class="sphere redgreen">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverSF">
              <span class="text-green-500">Sensing</span> & <span class="text-red-500">Feeling</span>
            </div>
          </transition>
        </a>
    </div>
    <div class="map-section w-1/3">
        <a @mouseover="hoverEF = true" @mouseout="hoverEF = false" href="/magnificent16/treelogy/EF" class="sphere red">
            <transition name="fade">
              <div class="text-reveal" v-show="hoverEF">
                Extraverted <span class="text-red-500">Feeling</span>
              </div>
            </transition>
          </a>
    </div>
    <div class="map-section w-1/3">
        <a @mouseover="hoverNF = true" @mouseout="hoverNF = false" href="/magnificent16/treelogy/NF" class="sphere yellowred">
          <transition name="fade">
            <div class="text-reveal" v-show="hoverNF">
              <span class="text-yellow-500">Intuition</span> & <span class="text-red-500">Feeling</span>
            </div>
          </transition>
        </a>
    </div>
  </div>
</div>
</template>
}
<script>
export default {

  props: ['title', 'icon', 'description'],

  data () {
  return {
      hoverWisdom: false,
      hoverET: false,
      hoverES: false,
      hoverEN: false,
      hoverEF: false,
      hoverSN: false,
      hoverST: false,
      hoverSF: false,
      hoverTF: false,
      hoverJP: false,
      hoverNT: false,
      hoverNF: false,
      hoverIT: false,
      hoverIS: false,
      hoverIN: false,
      hoverIF: false,
    }
  },
}
</script>